import React from 'react';

export const MEDIA_LIBRARY_MODAL_SEARCH_SLOT_ID = 'media-library-modal-search';

const MediaLibraryModalQueryContext = React.createContext(null);

export default MediaLibraryModalQueryContext;
